import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(Vuelidate);

/*--------------
 * START: Directives
 *-------------*/
let handleClick;
Vue.directive('documentClick', {
  bind(el, binding, vnode) {
    handleClick = (e) => {
      e.stopPropagation();
      const { handler } = binding.value;
      vnode.context[handler](e);
    };

    document.addEventListener('click', handleClick);
    document.addEventListener('touchstart', handleClick);
  },
  unbind() {
    document.removeEventListener('click', handleClick);
    document.removeEventListener('touchstart', handleClick);
  },
});

let handleResize;
let timeout;
Vue.directive('windowResize', {
  bind(el, binding, vnode) {
    handleResize = () => {
      const debounce = () => {
        const { handler } = binding.value;
        vnode.context[handler]();
      };
      clearTimeout(timeout);
      timeout = setTimeout(debounce, 250);
    };
    window.addEventListener('resize', handleResize);
  },
  unbind() {
    window.removeEventListener('resize', handleResize);
  },
});

let observer;
Vue.directive('mutationObserver', {
  bind(el, binding, vnode) {
    const config = { childList: true };
    const callback = (mutationsList) => {
      const { handler } = binding.value;
      vnode.context[handler](mutationsList[0]);
    };

    observer = new MutationObserver(callback);
    observer.observe(el, config);
  },
  unbind() {
    observer.disconnect();
  },
});
/*--------------
 * END: Directives
 *-------------*/

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
